import { NavLink } from "react-router-dom";
import { useState } from "react";
import logo from "../../resources/logo-small.png";
import ThemeChanger from "../../global/ThemeChanger";
import SearchWithNavigate from "../wp/SearchWithNavigate";
import "../../styles/navbar-custom.scss";

function Navbar({ userData, onLogout }) {
  const [open, setOpen] = useState(false);

  const collapseClass = `navbar-collapse custom-collapse${open ? " show" : ""}`;

  const handleToggle = () => setOpen((v) => !v);
  const handleNavClick = () => setOpen(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-light custom-navbar">
      <div className="container">
        <NavLink className="navbar-brand" to="/" onClick={handleNavClick}>
          <img src={logo} alt="Andrews Cookin Website Logo" width={160} />
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={open}
          aria-label="Toggle navigation"
          onClick={handleToggle}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={collapseClass} id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink to="/" end className={({ isActive }) => "nav-link" + (isActive ? " active" : "") } onClick={handleNavClick}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/recipes/" end className={({ isActive }) => "nav-link" + (isActive ? " active" : "") } onClick={handleNavClick}>
                Recipes
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/recipes/category/" className={({ isActive }) => "nav-link" + (isActive ? " active" : "") } onClick={handleNavClick}>
                Categories
              </NavLink>
            </li>
            <li className="nav-item">
              <a href="https://www.youtube.com/@AndrewsCookin" target="_blank" rel="noopener noreferrer" className="nav-link">
                YouTube
              </a>
            </li>
            <li className="nav-item d-lg-none navbar-themechanger">
              <ThemeChanger />
            </li>
          </ul>

          <div className="d-flex align-items-center">
            <div className="post-search-bar me-3">
              <SearchWithNavigate />
            </div>
            <div className="d-none d-lg-flex align-items-center navbar-themechanger">
              <ThemeChanger />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
